import { Grid, Button, Box } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile, browserName } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import GlobalApi from "../../utils/GlobalApi";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import SingleTabEnforcer from "../../components/SingleTabEnforcer/SingleTabEnforcer";
const header = {
  headers: {
    // "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  waitingLabel: {
    fontSize: "22px",
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    textAlign: "center",
    padding: "20px 0",
    "& span": {
      fontWeight: "bold",
    },
  },
  waitingSubLabel: {
    fontSize: "20px",
    fontFamily: "DB Heavent",
    textAlign: "center",
    marginBottom: "15px",
  },
  waitingImg: {
    display: "block",
    margin: "auto",
    marginTop: "8px",
    width: "80px",
  },
});
const AtsWaiting = (props) => {
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const registerRequestData = getData("registerRequestData")
    ? getData("registerRequestData")
    : "";
  const classes = useStyle();
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModal, setIsModal] = useState(false);
  let CheckStatusAts;
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  const statusLoading = ["created", "create", ""];
  const statusSucess = ["success", "0000"];
  const statusError = ["reject", "cancel", "error", "timeout"];
  const [showStatus, setShowStatus] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const statusDesc = urlParams.get("statusDesc");
  let checkErrorAts = 0;
  useEffect(() => {
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  useEffect(() => {
    checkJumpPage().then(async (res) => {
      if (res) {

        setJumpPage(true);
      } else {
        let ats_ref = registerRequestData.ats_ref;
        let bank_code = registerRequestData.bankCode;
        const HeaderManp = getData("HeaderManp");
        let head_token = HeaderManp.head_token;
        let bankURL = registerRequestData.ats_link;    
        if (statusDesc && statusDesc !== "Success") {
          setIsLoading(false);
          setModalErrorTitle("เกิดข้อผิดพลาด");
          setModalErrorDes(
            "สมัครบริการหักบัญชีอัตโนมัติ ( ATS ) ไม่สำเร็จ <br>โปรดติดต่อ DAOL Contact Center 0 2351 1800 เพื่อทำการสมัครฯ ผ่านช่องทางอื่น"
          );
          setIsModalError(true);
          return clearInterval(CheckStatusAts);
        } else {
          await GlobalApi.post(`${Configs.baseAPIURL03}/form/ats/selbyhead`, {
            head_token: head_token,
            bank_code: bank_code,
            ats_ref: ats_ref,
          })
            .then(async (res) => {
              let intervalATSData = res.data.Data[0];
              console.log(intervalATSData);
              
              if (intervalATSData.ats_status) {
                if (statusLoading.includes(intervalATSData.ats_status)) {
                  try {
                    window.open(bankURL, "_blank").focus();
                  } catch (e) {
                    if (browserName == "Mobile Safari") {
                      setIsModalError(true);
                      setModalErrorTitle(`ไม่สามารถดำเนินการต่อได้`);
                      setModalErrorDes(
                        "กรุณาตั้งค่าอนุญาตการเข้าถึง Pop-ups ที่เมนู ตั้งค่า (Settings) > Safari > ปิดกั้นหน้าต่างที่แสดงขึ้น (Block Pop-ups) เลื่อนปุ่มเพื่อเปลี่ยนจากสีเขียวเป็นสีเทา"
                      );
                      return;
                    } else if (browserName == "Safari") {
                      setIsModalError(true);
                      setModalErrorTitle(`ไม่สามารถดำเนินการต่อได้`);
                      setModalErrorDes(
                        "กรุณาตั้งค่าอนุญาตการเข้าถึง Pop-ups ที่ Safari เลือก Preferences > Websites > Pop-ups และคลิก Allow"
                      );
                      return;
                    }
                    return;
                  }

                  check_status(registerRequestData);
                } else {
                  setIsLoading(true);
                  check_status(registerRequestData);
                }
              } else {
                setIsLoading(false);
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes(
                  "สมัครบริการหักบัญชีอัตโนมัติ ( ATS ) ไม่สำเร็จ <br>โปรดติดต่อ DAOL Contact Center 0 2351 1800  เพื่อทำการสมัครฯ ผ่านช่องทางอื่น"
                );
                setIsModalError(true);
              }
            })
            .catch((error) => {
              setIsLoading(false);
              if (
                error.response &&
                error.response.data &&
                error.response.data.MsgDesc &&
                error.response.data.MsgDesc.message
              ) {
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes(error.response.data.MsgDesc.message);
              } else if (
                error.response &&
                error.response.data &&
                error.response.data.MsgDesc
              ) {
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes(error.response.data.MsgDesc);
              } else {
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes(
                  "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
                );
              }
              setIsModalError(true);
              return clearInterval(CheckStatusAts);
            });
        }
      }
    });
  }, []);
  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(registerRequestData)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const check_status = async (requestBankMapping) => {
    CheckStatusAts = setInterval(async function () {
      let url_string = window.location.href;
      let url = new URL(url_string);
      let ats_ref = requestBankMapping.ats_ref;
      let bank_code = requestBankMapping.bankCode;
      const HeaderManp = getData("HeaderManp");
      let head_token = HeaderManp.head_token;
      if (!url.pathname.includes("ats_waiting")) {
        return clearInterval(CheckStatusAts);
      }
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      const data = {
        head_token: head_token,
        bank_code: bank_code,
        ats_ref: ats_ref,
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/ats/selbyhead`,
        data,
        header,
      )
        .then(async (res) => {
          let intervalATSData = res.data.Data[0];
          if (intervalATSData.ats_status) {
            checkErrorAts = 0;
            setShowStatus(intervalATSData.ats_status);
            if (statusLoading.includes(intervalATSData.ats_status)) {
              // clearInterval(CheckStatusAts);
            }
            if (statusSucess.includes(intervalATSData.ats_status)) {
              clearInterval(CheckStatusAts);
              const ats_data = {
                f7_isother: "0",
                add_account_json: [
                  {
                    SAfba_Id: "0", //  fix เป็นค่า 0
                    SAfba_SAmbk_Id: registerRequestData.BankId, // "BankId"
                    SAfba_SAmbkb_Id: "", // "BranchId" เพิ่มใหม่ ส่งเป็นค่า 0
                    SAfba_SAmbkt_Id: "", // เลขidของ ประเภทบัญชี ส่งค่าว่าง
                    SAfba_AccountNo: intervalATSData.ats_account_no, // "BankAccountNo" “”:
                    SAfba_AccountName: intervalATSData.ats_account_name
                      ? intervalATSData.ats_account_name
                      : registerRequestData.textAccount,
                    SAfba_UseATS: "1", // ATSFlag ให้ตัดเงินด้วย ATS หรือไม่ใช่“1” ไม่ใช่“0”
                    SAfba_UseDividend: "0", // fix เป็นค่า 0
                  },
                ],
              };
              console.log(intervalATSData.ats_account_name);

              storeData("f7_ats", ats_data);
              await saveComeback();
            }
            if (statusError.includes(intervalATSData.ats_status)) {
              setIsLoading(false);
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(
                "สมัครบริการหักบัญชีอัตโนมัติ ( ATS ) ไม่สำเร็จ <br>โปรดติดต่อ DAOL Contact Center 0 2351 1800 เพื่อทำการสมัครฯ ผ่านช่องทางอื่น",
              );
              setIsModalError(true);
              return clearInterval(CheckStatusAts);
            }
          }
        })
        .catch((error) => {
          checkErrorAts++;
          if (checkErrorAts === 3) {
            clearInterval(CheckStatusAts);
            setIsLoading(false);
            if (
              error.response &&
              error.response.data &&
              error.response.data.MsgDesc &&
              error.response.data.MsgDesc.message
            ) {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(error.response.data.MsgDesc.message);
            } else if (
              error.response &&
              error.response.data &&
              error.response.data.MsgDesc
            ) {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(error.response.data.MsgDesc);
            } else {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(
                "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
              );
            }
            setIsModalError(true);
          }
        });
    }, 5000);
  };
  const popUps = (e) => {
    clearData("requestBankMapping");
    props.history.push("/summary");
  };
  const popUpError = (e) => {
    clearInterval(CheckStatusAts);
    props.history.push("ats_apply");
  };
  const bankName = (ats_data) => {
    return registerRequestData.bank_name === "kbank"
      ? "กสิกร"
      : registerRequestData.bankCode === "scb"
        ? "ไทยพาณิชย์"
        : "";
  };
  const saveComeback = async () => {
    setIsLoading(true);
    storeData("stamp_page", "SUMMARY");
    const atsdata = await getData("f7_ats");
    var last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
    const saveData = [
      {
        name: "ats",
        url: `${Configs.baseAPIURL03}/form/bank_account/manp`,
        postData: {
          head_token: head_token,
          f7_isother: atsdata.f7_isother,
          add_account_json: atsdata.add_account_json,
        },
      },
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUMMARY",
        },
      },
    ];
    setIsLoading(true);
    for (let i = 0; i < saveData.length; i++) {
      try {
        await GlobalApi.post(saveData[i].url, saveData[i].postData, header)
          .then((res) => {
            if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
              clearData("f7_ats");
              clearData("f7_bank_ats");
              let mss =
                res.data.Data[0].MsgDesc !== ""
                  ? res.data.Data[0].MsgDesc
                  : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
              let title = "เกิดข้อผิดพลาด";
              setIsLoading(false);
              setIsModalError(true);
              setModalErrorTitle(title);
              setModalErrorDes(mss);
            } else {
              // console.log("save " + saveData[i].name + "  success");
              if (i === saveData.length - 1) {
                setIsLoading(false);
                setIsModal(true);
              }
            }
          })
          .catch((er) => {
            // console.log(er);
            clearData("f7_ats");
            clearData("f7_bank_ats");
            // console.log("save " + saveData[i].name + "  error");
            i = saveData.length;
            setIsLoading(false);
            let title = "เกิดข้อผิดพลาด";
            let mss =
              "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
              getData("api_error")?.message +
              ")";
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          });
      } catch (error) {
        // console.log(error);
        i = saveData.length;
        clearData("f7_ats");
        clearData("f7_bank_ats");
        // console.log("catch" + saveData[i].name + "  error");
        setIsLoading(false);
        setIsModalError(true);
      }
    }
  };
  const goBack = (value) => {
    props.history.push("/ats_apply");
    return window.clearInterval(CheckStatusAts);
  };

  return (
    <>
      {jumpPage ? (
        <>
          {statusDesc ? (<SingleTabEnforcer jumpPage={jumpPage} />) : (<Grid className="app-splash-screen"></Grid>)}
        </>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ats?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? goBack() : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            switchType={(e) => popUpError(e)}
            imgModalError
            btnPrimary={"ตกลง"}
          />
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            imgModalSuccess
            switchType={(e) => popUps(e)}
            title={"สมัครบริการหักบัญชีอัตโนมัติ (ATS) สำเร็จ"}
            btnPrimary={"ถัดไป"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ats}
                        clickBack={(e) => goBack()}
                      //  ndid_list
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.ats?.title}
                          />
                          <ScrollBarComponent
                            isCheck={isCheck}
                            onChangeCheck={setIscheck}
                            content={
                              <Box>
                                <img
                                  className={classes.waitingImg}
                                  src={"images/ATS.png"}
                                  alt="ats"
                                />
                                <div className={classes.waitingLabel}>
                                  กรุณาดำเนินการสมัครบริการหักบัญชีอัตโนมัติ
                                  (ATS) ผ่านธนาคาร <span>{bankName()}</span>{" "}
                                  ให้เสร็จสิ้น
                                </div>

                                <div className={classes.waitingSubLabel}>
                                  ระบบจะดำเนินการต่อให้อัตโนมัติ
                                  {isMobile && <br />}
                                  หลังจากท่านสมัครเรียบร้อยแล้ว
                                </div>

                                {isMobile && (
                                  <div className={classes.waitingSubLabel}>
                                    หากท่านไม่พบขั้นตอนการสมัคร
                                    <br />
                                    กรุณาปลดบล็อก Pop-ups ในเมนู "ตั้งค่า"
                                    <br />
                                    บนอุปกรณ์ของท่าน เพื่อดำเนินการต่อ
                                  </div>
                                )}
                              </Box>
                            }
                          ></ScrollBarComponent>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(AtsWaiting);
